import React, { useMemo } from 'react';
import { getShortcutItems } from '../../constants/quizShortcuts';
import PopupMenuShortcuts from './PopupMenuShortcuts';
import PopupMenu from '../PopupMenu';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useQuizShortcutsContext } from '../../context/QuizShortcutsContext';
import { useIntl } from 'react-intl';

/**
 * KeyboardShortcuts component.
 */
const KeyboardShortcuts = () => {
  const {
    showKeyboardShortcuts,
    setShowKeyboardShortcuts,
    shortcuts,
    setShortcuts,
  } = useQuizShortcutsContext();

  const intl = useIntl();
  const shortcutItems = useMemo(() => getShortcutItems(intl), [intl]);

  const hide = () => setShowKeyboardShortcuts(false);

  return (
    <Flex flex={1} justifyContent="flex-end">
      <PopupMenu
        hideOnScroll={false}
        isVisible={showKeyboardShortcuts}
        hide={hide}
        keyExtractor={(item) => item.id}
        renderItem={(item) => (
          <PopupMenuShortcuts
            {...item}
            shortcuts={shortcuts}
            setShortcuts={setShortcuts}
          />
        )}
        items={shortcutItems}
        containerClasses="overflow-y-auto z-[1000] mt-[90px] min-w-[200px]"
        containerStyle={{
          maxWidth: 'calc(90vh - 10px)',
          maxHeight: 'calc(90vh - 100px)',
        }}
        popupItemIsFocusable={-1}
      >
        {null}
      </PopupMenu>
    </Flex>
  );
};

export default KeyboardShortcuts;
